import React, { useState } from "react";
import ChecklistCard from "../../ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import BCMustRefer from "../../BCMustRefer.js";
import clauseData from "../../../data/BritishColumbia/clauseData.js";
import clauseCardDesc from "../../../data/BritishColumbia/clauseCardDescription.js";
import importantNotes from "../../../data/BritishColumbia/importantNotes.js";
import ImportantNotes from "../../ImportantNotes.js";
import BackToTop from "../../BackToTop.js";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import BCClauseCard from "../../BCClauseCard.js";

export default function ResidentialPurchase() {
  const [SellerRep, setSellerRep] = useState("No");
  const [IsDisclosure, setIsDisclosure] = useState("No");
  const [APS, setAPS] = useState("Residential");
  const [ListingType, setListingType] = useState("MLS");
  const [BuyerRep, setBuyerRep] = useState("a Client");
  const [SellerNotice, setSellerNotice] = useState("No");
  const [CommissionPayer, setCommissionPayer] = useState("Seller");

  const [BuyerDocs, setBuyerDocs] = useState([
    "Disclosure of Representation in Trading Services",
    "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
    "Privacy Notice and Consent Form",
    "Related FINTRAC Documents",
  ]);
  const getSellerDocs = () => {
    const baseDocs = [
      "Disclosure of Representation in Trading Services",
      "Disclosure of Risks to Unrepresented Parties",
      "Privacy Notice & Consent Form",
      "Related FINTRAC Documents",
    ];

    return baseDocs;
  };

  const [DealDocs, setDealDocs] = useState([
    "Contract of Purchase & Sale (Residential)",
    "Addendums (if applicable)",
    "Property Disclosure Statement or PNDS",
    "Buyers Advisement (highly recommended)",
    "Disclosure of Remuneration",
    "Title Search",
    "Copy of Deposit & Receipt",
    "Full REALTOR® SOLD MLS Printout",
  ]);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const toggleDisclosure = (e) => {
    if (e.target.value === "Yes") {
      setIsDisclosure("Yes");
      if (
        DealDocs.includes("Disclosure of Interest in Trade (BCFSA Form)") ===
        true
      ) {
        return;
      } else {
        setDealDocs([
          ...DealDocs,
          "Disclosure of Interest in Trade (BCFSA Form)",
        ]);
      }
    } else {
      setIsDisclosure("No");
      setDealDocs(
        DealDocs.filter(
          (item) => item !== "Disclosure of Interest in Trade (BCFSA Form)"
        )
      );
    }
  };

  const setExclusive = (e) => {
    setListingType(e.target.value);
    setCommissionPayer("Seller");
    let newDealDocs = [...DealDocs];
    if (
      SellerRep === "No" &&
      !newDealDocs.includes("Confirm Remuneration amount with LA, in writing")
    ) {
      newDealDocs.push("Confirm Remuneration amount with LA, in writing");
    }

    newDealDocs = newDealDocs.filter(
      (item) => item !== "Full REALTOR® SOLD MLS Printout"
    );

    // Remove fee agreements for non-FSBO listing types
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !==
          "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)" &&
        item !==
          "Fee Agreement Buyer Pays (Buyer Represented and Seller Unrepresented Party)"
    );

    setDealDocs(newDealDocs);
  };

  const setMLS = (e) => {
    setListingType(e.target.value);
    setCommissionPayer("Seller");
    let newDealDocs = [...DealDocs];
    if (!newDealDocs.includes("Full REALTOR® SOLD MLS Printout")) {
      newDealDocs.push("Full REALTOR® SOLD MLS Printout");
    }

    newDealDocs = newDealDocs.filter(
      (item) => item !== "Confirm Remuneration amount with LA, in writing"
    );

    // Remove fee agreements for non-FSBO listing types
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !==
          "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)" &&
        item !==
          "Fee Agreement Buyer Pays (Buyer Represented and Seller Unrepresented Party)"
    );

    if (e.target.value === "Mere") {
      newDealDocs.push(
        "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)"
      );
    }

    setDealDocs(newDealDocs);
  };

  const handleFSBO = (e) => {
    setListingType("FSBO");
    let newDealDocs = [...DealDocs];

    // Remove "Full REALTOR® SOLD MLS Printout" for FSBO
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !== "Full REALTOR® SOLD MLS Printout" &&
        item !== "Confirm Remuneration amount with LA, in writing"
    );

    // Add Seller Fee Agreement for FSBO if not already present
    if (
      !newDealDocs.includes(
        "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)"
      )
    ) {
      newDealDocs.push(
        "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)"
      );
    }

    setDealDocs(newDealDocs);
  };

  const handleCommissionPayer = (e) => {
    setCommissionPayer(e.target.value);

    let newDealDocs = [...DealDocs];

    // Remove existing fee agreements first
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !==
        "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)"
    );
    newDealDocs = newDealDocs.filter(
      (item) =>
        item !==
        "Fee Agreement Buyer Pays (Buyer Represented and Seller Unrepresented Party)"
    );

    // Add the appropriate fee agreement based on who pays commission
    if (e.target.value === "Seller") {
      newDealDocs.push(
        "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)"
      );
    } else if (e.target.value === "Buyer") {
      newDealDocs.push(
        "Fee Agreement Buyer Pays (Buyer Represented and Seller Unrepresented Party)"
      );
    }

    setDealDocs(newDealDocs);
  };

  const handleSellerRep = (e) => {
    setSellerRep(e.target.value);
    if (e.target.value === "Yes") {
      setListingType("MLS");
      setCommissionPayer("Seller");
      let newDealDocs = [...DealDocs];

      // Remove fee agreements for non-FSBO listing types
      newDealDocs = newDealDocs.filter(
        (item) =>
          item !==
            "Fee Agreement Seller Pays (Buyer Represented and Seller Unrepresented Party)" &&
          item !==
            "Fee Agreement Buyer Pays (Buyer Represented and Seller Unrepresented Party)" &&
          item !== "Disclosure of Remuneration" &&
          item !== "Buyers Advisement (highly recommended)" &&
          item !== "Confirm Remuneration amount with LA, in writing"
      );

      if (newDealDocs.includes("Full REALTOR® SOLD MLS Printout") === true) {
        setDealDocs(newDealDocs);
      } else {
        newDealDocs.push("Full REALTOR® SOLD MLS Printout");
        setDealDocs(newDealDocs);
      }
    }
    if (e.target.value === "No") {
      if (e.target.value === SellerRep) {
        return;
      }
      setBuyerRep("a Client");
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
      if (ListingType === "Exclusive") {
        DealDocs.push("Confirm Remuneration amount with LA, in writing");
      }
      DealDocs.splice(3, 0, "Buyers Advisement (highly recommended)");
      DealDocs.splice(4, 0, "Disclosure of Remuneration");
    }
  };

  const handleBuyerRep = (e) => {
    setBuyerRep(e.target.value);
    if (e.target.value === "a Client") {
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Buyers Agency Exclusive Contract or Buyers Agency Acknowledgement (highly recommended)",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    } else {
      setBuyerDocs([
        "Disclosure of Representation in Trading Services",
        "Disclosure of Risks to Unrepresented Parties",
        "Privacy Notice and Consent Form",
        "Related FINTRAC Documents",
      ]);
    }
  };

  const changeAPS = (e) => {
    if (e.target.value === "Condo/Strata") {
      setAPS(e.target.value);
      let newdata = [...DealDocs];
      newdata.shift();
      newdata.unshift("Contract of Purchase & Sale (Residential)");

      // Add "Form B" to the 2nd slot (index 1) if not already present
      if (!newdata.includes("Form B")) {
        newdata.splice(1, 0, "Form B");
      }

      setDealDocs(newdata);
    } else {
      setAPS(e.target.value);
      let newdata = [...DealDocs];
      newdata.shift();
      newdata.unshift("Contract of Purchase & Sale (" + e.target.value + ")");

      // Remove "Form B" if present
      newdata = newdata.filter((item) => item !== "Form B");

      setDealDocs(newdata);
    }
  };

  const toggleSellerNotice = (e) => {
    if (SellerNotice === e.target.value) {
      return;
    }
    setSellerNotice(e.target.value);
    if (e.target.value === "Yes") {
      let newDealDocs = [...DealDocs];
      if (!newDealDocs.includes("Notice to Seller of Assignment Terms")) {
        newDealDocs.push("Notice to Seller of Assignment Terms");
      }
      if (
        !newDealDocs.includes(
          "Assignment Term(s) in Contract & Cross out 20A/20B in Contract"
        )
      ) {
        newDealDocs.push(
          "Assignment Term(s) in Contract & Cross out 20A/20B in Contract"
        );
      }
      setDealDocs(newDealDocs);
    } else {
      setDealDocs(
        DealDocs.filter(
          (item) =>
            item !== "Notice to Seller of Assignment Terms" &&
            item !==
              "Assignment Term(s) in Contract & Cross out 20A/20B in Contract"
        )
      );
    }
  };

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <ThemeProvider theme={theme}>
            <FormControl sx={{ mt: 3, mb: 1, minWidth: 325, maxWidth: 110 }}>
              <InputLabel size="small" className="select-default-label">
                Property Type
              </InputLabel>
              <Select
                value={APS}
                name="Property Type"
                label="Property Type"
                onChange={changeAPS}
                size="small"
                sx={{ borderRadius: 20 }}
              >
                <MenuItem key={Math.random()} value="Residential">
                  Single Family Residential
                </MenuItem>
                <MenuItem key={Math.random()} value="Condo/Strata">
                  Condo/Strata
                </MenuItem>

                <MenuItem key={Math.random()} value="Manufactured">
                  Mobile/Modular/Manufactured
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="Leasehold - 3rd Party Approval Not Required"
                >
                  Leasehold - 3rd Party Not Required
                </MenuItem>
                <MenuItem
                  key={Math.random()}
                  value="Leasehold - 3rd Party Approval Required"
                >
                  Leasehold - 3rd Party Required
                </MenuItem>
              </Select>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-3">
            Do you also represent the Seller in this transaction?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={handleSellerRep} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {SellerRep === "Yes" ? (
            <>
              <div className="pr-5 pt-5">Buyer's Representation?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    defaultValue="a Client"
                    value={BuyerRep}
                  >
                    <FormControlLabel
                      value="a Client"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Client"
                    />
                    <FormControlLabel
                      value="an Unrepresented Party"
                      control={<Radio size="small" onClick={handleBuyerRep} />}
                      label="Unrepresented Party"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          ) : (
            ""
          )}
          <div className="pr-5 pt-5">Type of Listing?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="MLS"
                value={ListingType}
              >
                <FormControlLabel
                  value="MLS"
                  control={<Radio size="small" onClick={setMLS} />}
                  label="MLS"
                />
                <FormControlLabel
                  value="Exclusive"
                  control={<Radio size="small" onClick={setExclusive} />}
                  label="Exclusive"
                />
                {SellerRep !== "Yes" ? (
                  <>
                    <FormControlLabel
                      value="Mere"
                      control={<Radio size="small" onClick={setMLS} />}
                      label="Mere Posting"
                    />
                    <FormControlLabel
                      value="FSBO"
                      control={<Radio size="small" onClick={handleFSBO} />}
                      label="For Sale By Owner"
                    />
                  </>
                ) : (
                  ""
                )}
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          {ListingType === "FSBO" && (
            <>
              <div className="pr-5 pt-5">Who will Pay Commission?</div>
              <ThemeProvider theme={theme}>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                    value={CommissionPayer}
                  >
                    <FormControlLabel
                      value="Seller"
                      control={
                        <Radio size="small" onClick={handleCommissionPayer} />
                      }
                      label="Seller"
                    />
                    <FormControlLabel
                      value="Buyer"
                      control={
                        <Radio size="small" onClick={handleCommissionPayer} />
                      }
                      label="Buyer"
                    />
                  </RadioGroup>
                </FormControl>
              </ThemeProvider>
            </>
          )}
          <div className="pr-5 pt-5">
            Will you potentially add/change Buyers or assign the contract?
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={toggleSellerNotice} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={toggleSellerNotice} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
          <div className="pr-5 pt-5">
            {SellerRep === "No"
              ? `Are you or immediate family members purchasing this property?`
              : `Are you or any of your close relatives the Buyer or the Seller?`}
          </div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="No"
              >
                <FormControlLabel
                  value="Yes"
                  control={<Radio size="small" onClick={toggleDisclosure} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="No"
                  control={<Radio size="small" onClick={toggleDisclosure} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>

      {SellerRep === "Yes" && BuyerRep === "a Client" ? (
        <BCMustRefer IsMLS={ListingType} />
      ) : (
        <>
          {ListingType === "Mere" || ListingType === "FSBO" ? (
            <ChecklistCard
              province={"BC"}
              CheckListData={BuyerDocs}
              CheckListData2={getSellerDocs()}
              CheckListData3={DealDocs}
              Header={"Purchase:"}
              Header2={"Buyer is " + BuyerRep}
              Title1="Buyer Documents"
              Title2="Seller Documents"
              Title3="Deal Documents"
            />
          ) : (
            <ChecklistCard
              province={"BC"}
              CheckListData={BuyerDocs}
              CheckListData2={DealDocs}
              Header={"Purchase:"}
              Header2={"Buyer is " + BuyerRep}
              Title1="Buyer Documents"
              Title2="Deal Documents"
            />
          )}
        </>
      )}

      {SellerRep === "Yes" &&
      BuyerRep === "a Client" &&
      IsDisclosure === "Yes" ? (
        ""
      ) : ListingType === "Mere" || ListingType === "FSBO" ? (
        <BCClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("mere")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) => item.category.includes("mere") && item.isCommon === "yes"
          )}
          ClauseDataSituational={clauseData.filter(
            (item) => item.category.includes("mere") && item.isCommon === "no"
          )}
        />
      ) : (
        <BCClauseCard
          ClauseCardDescription={clauseCardDesc.filter((item) =>
            item.category.includes("residential")
          )}
          ClauseDataCommon={clauseData.filter(
            (item) =>
              (APS !== "Condo/Strata" &&
                item.category.includes("residential") &&
                item.isCommon === "yes") ||
              (APS === "Condo/Strata" &&
                item.category.includes("condo") &&
                item.isCommon === "yes")
          )}
          ClauseDataSituational={clauseData.filter(
            (item) =>
              (APS !== "Condo/Strata" &&
                item.category.includes("residential") &&
                item.isCommon === "no") ||
              (APS === "Condo/Strata" &&
                item.category.includes("condo") &&
                item.isCommon === "no") ||
              (SellerNotice === "Yes" &&
                item.category.includes("20A") &&
                item.isCommon === "no")
          )}
        />
      )}

      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong>Important Notes:</strong>
        <div className="pb-3"></div>

        {IsDisclosure === "Yes" ? (
          <ImportantNotes
            Notes={importantNotes.filter(
              (notes) => notes.category.includes("disclosure") === true
            )}
          />
        ) : (
          ""
        )}

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes(APS) === true
          )}
        />
        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("purchase") === true
          )}
        />
      </div>
      <BackToTop />
    </div>
  );
}
